import { useMapElement } from '../contextProviders/MapElementProvider';
import ProcessConfiguration from './ProcessConfiguration';
import ProcessDetails from './ProcessDetails';
import OutcomeDetails from '../common/OutcomeDetails';
import ProcessPropertiesDetails from './ProcessPropertiesDetails';
import screens from '../common/screens';

const ProcessRouter = () => {
    const {
        currentScreen,
        mapElement,
        onSwitchScreen,
        selectedOutcomeIndex,
        setSelectedOutcomeIndex,
    } = useMapElement();

    switch (currentScreen) {
        case screens.process:
            return <ProcessConfiguration />;

        case screens.processDetails:
            return <ProcessDetails />;

        case screens.processProperties:
            return <ProcessPropertiesDetails />;

        case screens.outcome: {
            const selectedOutcome = mapElement.outcomes?.[selectedOutcomeIndex ?? 0] ?? null;

            return (
                <OutcomeDetails
                    outcome={selectedOutcome}
                    onSave={() => onSwitchScreen(screens.process)}
                    onCancel={() => {
                        onSwitchScreen(screens.process);
                        setSelectedOutcomeIndex(null);
                    }}
                />
            );
        }
        default:
            return null;
    }
};

export default ProcessRouter;
